let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('3VcRJ') + "../../" + require('./helpers/bundle-manifest').resolve("6brh7");module.exports = workerURL(url, bundleURL.getOrigin(url), false);